import { render, staticRenderFns } from "./wxColophon.vue?vue&type=template&id=668f963a"
import script from "./wxColophon.vue?vue&type=script&lang=js"
export * from "./wxColophon.vue?vue&type=script&lang=js"
import style0 from "./wxColophon.vue?vue&type=style&index=0&id=668f963a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports